export default "__VITE_ASSET__BmdP_VoZ__"